import LandingDynamicWorkflow from './landingDynamicWorkflow';
import { LandingState, LandingAction, LandingActionKind } from './types';

export const initialState: LandingState = {
  dynamicWorkflows: [],
  filteredWorkflows: [],
  isLoading: false
};

export function landingReducer(state: LandingState, action: LandingAction) {
  const { type, payload } = action;

  switch (type) {
    case LandingActionKind.SET_DYNAMICWORKFLOWS:
      return {
        ...state,
        dynamicWorkflows: payload as LandingDynamicWorkflow[],
        filteredWorkflows: payload as LandingDynamicWorkflow[]
      };
    case LandingActionKind.SET_ISLOADING:
      return {
        ...state,
        isLoading: payload as boolean
      };
    case LandingActionKind.SEARCH_DYNAMICWORKFLOWS:
      return {
        ...state,
        filteredWorkflows: payload as LandingDynamicWorkflow[]
      };
    default:
      return state;
  }
}
